import { render } from "./LoginPassword.vue?vue&type=template&id=195c4f7c&scoped=true"
import script from "./LoginPassword.vue?vue&type=script&lang=js"
export * from "./LoginPassword.vue?vue&type=script&lang=js"

import "./LoginPassword.vue?vue&type=style&index=0&id=195c4f7c&lang=scss&scoped=true"
import "./LoginPassword.vue?vue&type=style&index=1&id=195c4f7c&lang=scss"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-195c4f7c"]])

export default __exports__